<template>

</template>

<script>
import {getPreAuthorizeFlag, getTokenLogin} from '@/api'
import {setToken} from "@/utils/auth";
import store from "@/store";
import { mapMutations } from "vuex"

export default {
  name: "transfer",
  created() {
    if (this.$route.query && this.$route.query.loginkey) {
      let token = this.$route.query.loginkey;
      getTokenLogin({loginkey: token}).then(response => {
        if (response.data.access_token) {
          setToken(response.data.access_token)
          store.dispatch('GetInfo').then(() => {
            this.SET_TOKEN(response.data.access_token)
            if (this.$route.query && this.$route.query.resourceId) {
              getPreAuthorizeFlag(this.$route.query.resourceId).then(res => {
                if (res.data) {
                  window.location.href = this.$route.query.url + '&flag=' + this.$route.query.flag
                  if (this.$route.query.url.indexOf('?') !== -1) {
                    if (this.$route.query.flag) {
                      window.location.href = this.$route.query.url + '&flag=' + this.$route.query.flag
                    } else if (this.$route.query.id) {
                      window.location.href = this.$route.query.url + '&id=' + this.$route.query.id
                    } else {
                      window.location.href = this.$route.query.url
                    }
                  } else {
                    if (this.$route.query.flag) {
                      window.location.href = this.$route.query.url + '&flag=' + this.$route.query.flag
                    } else if (this.$route.query.id) {
                      window.location.href = this.$route.query.url + '&id=' + this.$route.query.id
                    } else {
                      window.location.href = this.$route.query.url
                    }
                  }
                } else {
                  this.$router.push({path:'/', query:{tokenFlag:'1'}})
                }
              })
            } else {
              this.$router.push('/')
            }
          }).catch(err => {
            console.log(err)
          })
        } else {
          this.$router.push('/')
        }
      })
    } else {
      this.$router.push('/')
    }
  },
  methods:{
    ...mapMutations(["SET_TOKEN"]),
  }
}
</script>

<style scoped>

</style>
